'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ping = void 0; /* global window */

var visibility = void 0;
var overlay = void 0;
var history = void 0;

var engagePingCDN = '//sdk.pulse.schibsted.com/plugins/activity-pings/plugin.js';
var engageVisibilityCDN = '//sdk.pulse.schibsted.com/plugins/visibility-tracking/plugin.min.js';
var engageOverlayCDN = '//sdk.pulse.schibsted.com/plugins/engage-overlay/plugin.min.js';
var engageLocalHistoryCDN = '//sdk.pulse.schibsted.com/plugins/local-history/plugin.min.js';

exports.default = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$trackerId = _ref.trackerId,
        trackerId = _ref$trackerId === undefined ? 'web-sdk' : _ref$trackerId,
        pingOptions = _ref.pingOptions,
        visibilityOptions = _ref.visibilityOptions,
        _ref$overlayOptions = _ref.overlayOptions,
        overlayOptions = _ref$overlayOptions === undefined ? { enabled: false } : _ref$overlayOptions,
        historyOptions = _ref.historyOptions;

    var loadPing = ping ? _promise2.default.resolve() : (0, _util.load)(engagePingCDN).then(function () {
        window.pulse(trackerId + '.require', 'engagementTime', pingOptions);
        ping = true;
    });

    var loadVisibility = visibility ? _promise2.default.resolve() : (0, _util.load)(engageVisibilityCDN).then(function () {
        window.pulse(trackerId + '.require', 'visibilityTracking', visibilityOptions);
        visibility = true;
    });

    var loadOverlay = overlay || !overlayOptions.enabled ? _promise2.default.resolve() : (0, _util.load)(engageOverlayCDN).then(function () {
        var enabled = overlayOptions.enabled,
            overlayOpts = (0, _objectWithoutProperties3.default)(overlayOptions, ['enabled']);

        window.pulse(trackerId + '.require', 'engageOverlay', overlayOpts);
        overlay = true;
    });

    var loadLocalHistory = history ? _promise2.default.resolve() : (0, _util.load)(engageLocalHistoryCDN).then(function () {
        window.pulse(trackerId + '.require', 'localHistory', historyOptions);
        history = true;
    });

    return _promise2.default.all([loadPing, loadVisibility, loadOverlay, loadLocalHistory]);
};
//# sourceMappingURL=engage.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/~/@spp/tracking/lib/cjs/trackers/pulse/loaders/engage.js
 ** module id = 631
 ** module chunks = 1
 **/